// extracted by mini-css-extract-plugin
export default {"carousel":"FlowCarousel_carousel__ccYyr","imageWrapper":"FlowCarousel_imageWrapper__GDR2a","innerWrapper":"FlowCarousel_innerWrapper__CUqNE"};